module.exports = __webpack_public_path__ + "static/family1-386fdfb13a692c82474fc16656ebc946.jpg";